import React, { useEffect } from "react";
import './CSS/Shop.css';
import Hero from '../Components/Hero/Hero';
import NewCollections from '../Components/NewCollections/NewCollections';
import Banners from '../Components/Banners/Banners';
import NikeProducts from "../Components/NikeProducts/NikeProducts";
import ConverseProducts from "../Components/ConverseProducts/ConverseProducts";
import MidDisplay from "../Components/MidDisplay/MidDisplay";
import AdidasProducts from "../Components/AdidasProducts/AdidasProducts";

const Shop = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top when component mounts
    }, []); // Added empty dependency array to ensure it only runs once on mount

    return (
        // The main container for our homepage sections
        <div className="homepage">
            <Hero />
            <Banners />
            <NikeProducts />
            <ConverseProducts />
            <MidDisplay />
            <AdidasProducts />
            <NewCollections />
            {/* The <br /> tags have been removed. We will handle spacing in CSS. */}
        </div>
    );
}

export default Shop;